import AuthComponent from "@components/auth/component";
import DeleteButton from "@components/buttons/DeleteButton";
import EditButton from "@components/buttons/EditButton";
import { TProduct } from "@type-defs/product/TProduct";
import { thousandSeperator } from "@utils/general/digit-separators";

export const productPriceColumns = (
  editHandler: (product: TProduct) => void,
  deleteHandler: () => void
) => [
  {
    name: "Product Code",
    selector: (row: TProduct) =>
      row.product_code_prefix
        ? `${row.product_code_prefix}${row.product_code}`
        : `${row.product_code}`,
    wrap: true,
    minWidth: "150px",
  },
  {
    name: "Product Name",
    selector: (row: TProduct) => row.product_name,
    wrap: true,
    minWidth: "200px",
  },
  // {
  //   name: "Barcode",
  //   selector: (row: TProduct) => row.barcode || "-",
  //   wrap: true,
  //   minWidth: "100px",
  // },
  {
    name: "Product Category",
    selector: (row: TProduct) =>
      row.product_category_name || row.product_category_id,
    wrap: true,
    minWidth: "200px",
  },
  // {
  //   name: "Product Brand",
  //   selector: (row: TProduct) => row.product_tag_name || row.product_tag_id,
  //   wrap: true,
  //   minWidth: "200px",
  // },
  {
    name: "Unit Name",
    selector: (row: TProduct) => row.unit_name,
    wrap: true,
    minWidth: "80px",
  },
  // {
  //   name: "Base Unit Name",
  //   selector: (row: TProduct) => row.unit_name || row.unit_id,
  //   wrap: true,
  //   minWidth: "150px",
  // },
  // {
  //   name: "Unit Type",
  //   selector: (row: TProduct) => row.unit_type_name || row.unit_type_id,
  //   wrap: true,
  //   minWidth: "150px",
  // },
  {
    name: "Primary Sale Price",
    selector: (row: TProduct) => thousandSeperator(row.primary_sales_price),
    minWidth: "200px",
    center: true,
  },
   {
    name: "Secondary Sale Price",
    selector: (row: TProduct) => thousandSeperator(row.secondary_sales_price),
    minWidth: "200px",
    center: true,

  },
  {
    name: "Direct Sale Price",
    selector: (row: TProduct) => thousandSeperator(row.direct_sales_price),
    minWidth: "200px",
    center: true,

  },
  {
    name: "Action",
    right: true,
    selector: (row: TProduct) => (
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <AuthComponent
          action="edit"
          module="Product"
          subModule="Product Price"
        >
          <EditButton
            id={row.product_id}
            actionHandler={() => editHandler(row)}
          />
        </AuthComponent>

        <AuthComponent
          action="delete"
          module="Product"
          subModule="Product Price"
        >
          <DeleteButton id={row.product_id} actionHandler={deleteHandler} />
        </AuthComponent>
      </div>
    ),
    minWidth: "150px",
  },
];
